import { formatters } from "@/helpers/formatters";
import { InputDictionary } from "@/types/common";

export default <InputDictionary[]>[
  {
    title: "Advertiser",
    value: "advertiser",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Agency",
    value: "agency",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "DMA",
    value: "dma",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Data Type",
    value: "data_type",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Store",
    value: "store",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "B2B / B2C",
    value: "b2b_b2c",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Business Goal",
    value: "business_goal",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Campaign",
    value: "campaign",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Campaign KPI",
    value: "campaign_kpi",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Campaign ID",
    value: "campaign_id",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Channel",
    value: "channel",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Channel Detail",
    value: "channel_detail",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Channel Objective",
    value: "channel_objective",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "DSP",
    value: "dsp",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Funnel Stage",
    value: "funnel_stage",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Industry",
    value: "industry",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Media Type",
    value: "media_type",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Publisher",
    value: "publisher",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
  {
    title: "Sub-industry",
    value: "sub_industry",
    formatter: formatters.stringFormat,
    table: { group: "dimensions" },
  },
];
